import { styled } from "styled-components";
import { motion } from "framer-motion";
import { Colors, ButtonVariants } from "../constants.js";

const Wrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${Colors.Red};
  border-radius: 16px;
  color: ${Colors.Tan};
  padding: 16px;
  gap: 8px;
  outline: none;
  border: none;
  box-shadow: 0 6px 0px ${Colors.RedDark};
  cursor: pointer;
  font-family: "Space Grotesk", sans-serif;
  flex: 1;
  @media (max-width: 800px) {
    flex: none;
  }
`;

const Title = styled.div`
  font-size: 14px;
  line-height: 100%;
  text-transform: uppercase;
  font-weight: bold;
  color: ${Colors.Tan};
`;

const Description = styled(Title)`
  font-weight: normal;
  text-transform: none;
  line-height: 140%;
`;

const CharacterAction = ({ character, action, onClick }) => {
  return (
    <Wrapper
      variants={ButtonVariants}
      initial={"initial"}
      whileHover={"whileHover"}
      whileTap={"whileTap"}
      onClick={onClick}
    >
      <Title>
        {action.name} • D20
        {character.bonuses[action.stat] === 0
          ? ""
          : character.bonuses[action.stat] < 0
          ? character.bonuses[action.stat]
          : "+" + character.bonuses[action.stat]}
      </Title>
      <Description>{action.description}</Description>
    </Wrapper>
  );
};

export default CharacterAction;
